export default __webpack_public_path__ + "static/media/a024-5.0c956faa.svg";